const oidc = {
    logout_success: '성공적으로 로그아웃했습니다.',
};
export default Object.freeze(oidc);
